import { Button, Col, Pagination, Row, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import pushApi from '../../api/push.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import styles from '../../styles/sales.module.scss'

const AppPushTemplateListPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [appPushTemplateList, setAppPushTemplateList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [totalPages, setTotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)

  const getAppPushTemplateList = async (
    currentPage = page,
    size = pageSize,
  ) => {
    setIsLoading(true)
    try {
      const res = await pushApi.getAppPushTemplates({
        page: currentPage - 1, // API는 0-based index 사용
        size: size,
        sort: 'createdAt,desc',
      })
      // console.log(res)
      setAppPushTemplateList(res.data.content)
      setTotalPages(res.data.totalPages)
      setTotalElements(res.data.totalElements)
    } catch (error) {
      console.error('템플릿 목록 조회 실패:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAppPushTemplateList()
  }, [])

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log('selectedRows', selectedRows)
      setSelectedRowKeys(selectedRowKeys)
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
    }),
  }

  const columns = [
    {
      title: '템플릿 번호',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '템플릿 이름',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '푸시 제목',
      dataIndex: 'pushTitle',
      key: 'pushTitle',
    },
    {
      title: '푸시 내용',
      dataIndex: 'pushBody',
      key: 'pushBody',
    },
    {
      title: '푸시 URL',
      dataIndex: 'pushUrl',
      key: 'pushUrl',
      render: (_, record) => {
        return (
          <div
            style={{
              cursor: 'pointer',
              textAlign: 'center',
            }}
          >
            {record.pushUrl || '-'}
          </div>
        )
      },
    },
    {
      title: '이미지',
      dataIndex: 'pushImageUrl',
      key: 'pushImageUrl',
      render: (_, record) => {
        return (
          <>
            {record.pushImageUrl ? (
              <img
                src={record.pushImageUrl}
                alt="푸시 이미지"
                style={{
                  maxWidth: '100px',
                  maxHeight: '100px',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <div style={{ textAlign: 'center' }}>-</div>
            )}
          </>
        )
      },
    },
    {
      title: '템플릿 생성일',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => a.createdAt - b.createdAt,
    },
  ]

  const handleRowClick = (record) => {
    console.log(record)
    navigate(`/appPush/templates/${record.id}`)
  }

  return (
    <>
      <ContentHeader title="푸시 템플릿 조회/수정/삭제" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        {/*푸시 템플릿 조회 status*/}
        <Row
          justify="space-around"
          className={`${styles['product-search-product-status-wrap']}`}
        >
          {/*전체*/}
          <Col className={`${styles['product-status-box-col-wrap']}`} span={6}>
            <Row className={`${styles['product-status-box-wrap']}`}>
              <img
                className={`${styles['product-status-icon']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/product/total_product.png`}
              />
              <div className={`${styles['product-status-text']}`}>
                <div>전체</div>
                <div>
                  <span className={`${styles['product-status-num']}`}>
                    {appPushTemplateList?.length}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>
        {/*푸시 템플릿 목록*/}
        <Row
          justify="space-between"
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            템플릿 목록 (총{' '}
            <span
              className={`${styles['product-register-box-subtitle']}`}
              style={{ marginLeft: 0 }}
            >
              {appPushTemplateList?.length}
            </span>
            개)
          </span>
          <Button
            type="primary"
            onClick={() => navigate('/appPush/templates/register')}
          >
            템플릿 등록
          </Button>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={appPushTemplateList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey={(record) => record.id}
            rowClassName="app-push-template-table-row"
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            pagination={false}
            style={{ height: 'fit-content', cursor: 'pointer' }}
          />
          <Pagination
            showSizeChanger
            pageSize={pageSize}
            current={page}
            total={totalElements}
            onChange={(current, size) => {
              setPage(current)
              setPageSize(size)
              getAppPushTemplateList(current, size)
            }}
            onShowSizeChange={(current, size) => {
              setPage(1) // 페이지 크기가 변경되면 첫 페이지로 이동
              setPageSize(size)
              getAppPushTemplateList(1, size)
            }}
            style={{ marginTop: 20 }}
            align="end"
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} / 총 ${total}개`
            }
          />
        </div>
      </div>
    </>
  )
}

export default AppPushTemplateListPage
